import Vue from 'vue';
import {
  LOGOUT,
  CHECK_AUTHENTICATION,
  SET_MAINTENANCE_MODE,
  LOGIN,
  UPDATE_REFRESHING,
  TWO_FACTOR_VERIFICATION,
  CHECK_TWO_FACTOR_VERIFICATION,
} from './../../mutation-types';

export default {
  [CHECK_AUTHENTICATION](state) {
    state.authenticated = !!localStorage.getItem('id_token');
  },

  [LOGIN](state, token) {
    state.authenticated = true;
    localStorage.setItem('id_token', token);

    if (localStorage.getItem('id_token_save')) {
      localStorage.removeItem('id_token_save');
    }

    if (localStorage.getItem('user_id')) {
      localStorage.removeItem('user_id');
    }

    if (localStorage.getItem('verification_type')) {
      localStorage.removeItem('verification_type');
    }

    if (localStorage.getItem('mobile_number')) {
      localStorage.removeItem('mobile_number');
    }

    Vue.$http.defaults.headers.common.Authorization = `Bearer ${token}`;
  },

  [LOGOUT](state) {
    state.authenticated = false;
    localStorage.removeItem('id_token');

    if (localStorage.getItem('is_admin')) {
      localStorage.removeItem('is_admin');
    }

    Vue.$http.defaults.headers.common.Authorization = '';
  },

  [UPDATE_REFRESHING](state, value) {
    state.refreshing = value;
  },

  [SET_MAINTENANCE_MODE](state, status) {
    state.maintenance = status;
  },

  [TWO_FACTOR_VERIFICATION](state, { token, userId, verificationType, mobileNumber }) {
    state.twoFactorVerification = verificationType;
    localStorage.setItem('id_token_saved', token);
    localStorage.setItem('verification_type', verificationType);
    localStorage.setItem('user_id', userId);
    localStorage.setItem('mobile_number', mobileNumber);
  },
  [CHECK_TWO_FACTOR_VERIFICATION](state) {
    state.twoFactorVerification = localStorage.getItem('verification_type');
  },
};



// WEBPACK FOOTER //
// ./src/app/store/modules/auth/mutations.js